import React from 'react';
import { Box, FormControl, FormLabel, MenuItem, TextField } from '@mui/material';
import { LocaleText } from '../../../locale';
import { EFontFamily, EMarginSize, EPageOrientation } from '../types';
import { styles } from './ExportPdfControllers.styles';

export interface IExportPdfControllersProps {
  localeText: LocaleText;
  pageOrientation: string;
  setPageOrientation: (pageOrientation: EPageOrientation) => void;
  marginSize: string;
  setMarginSize: (marginSize: EMarginSize) => void;
  fontFamily: EFontFamily;
  setFontFamily: (fontFamily: EFontFamily) => void;
}

export const ExportPdfControllers: React.FC<IExportPdfControllersProps> = (props) => {
  const { localeText, pageOrientation, setPageOrientation, marginSize, setMarginSize, fontFamily, setFontFamily } =
    props;
  const { exportPdfModal } = localeText;

  return (
    <FormControl fullWidth sx={styles.formControl}>
      <FormLabel sx={styles.formLabel}>{localeText.exportPdfModal.exportSettingsTitle}</FormLabel>
      <Box sx={styles.formContent}>
        <TextField
          size="medium"
          select
          label={exportPdfModal.layoutLabel}
          value={pageOrientation}
          onChange={(e) => {
            setPageOrientation(e.target.value as EPageOrientation);
          }}
          fullWidth
          data-test="page-orientation-dropdown"
        >
          <MenuItem value={EPageOrientation.portrait} data-test="page-orientation-option-portrait">
            {exportPdfModal.portraitOrientation}
          </MenuItem>
          <MenuItem value={EPageOrientation.landscape} data-test="page-orientation-option-landscape">
            {exportPdfModal.landscapeOrientation}
          </MenuItem>
        </TextField>

        <TextField
          size="medium"
          select
          label={exportPdfModal.marginsLabel}
          value={marginSize}
          onChange={(e) => {
            setMarginSize(e.target.value as EMarginSize);
          }}
          fullWidth
          data-test="margin-dropdown"
        >
          <MenuItem value={EMarginSize.normal} data-test="margin-option-normal">
            {exportPdfModal.normalMargins}
          </MenuItem>
          <MenuItem value={EMarginSize.narrow} data-test="margin-option-narrow">
            {exportPdfModal.narrowMargins}
          </MenuItem>
        </TextField>

        <TextField
          size="medium"
          select
          label={exportPdfModal.fontFamilyLabel}
          value={fontFamily}
          onChange={(e) => {
            setFontFamily(e.target.value as EFontFamily);
          }}
          fullWidth
          data-test="font-family-dropdown"
        >
          {Object.keys(EFontFamily).map((ff) => (
            <MenuItem key={ff} value={ff} data-test={`font-family-option-${ff}`}>
              {exportPdfModal.fontFamilyOptions[ff as keyof typeof exportPdfModal.fontFamilyOptions]}
            </MenuItem>
          ))}
        </TextField>
      </Box>
    </FormControl>
  );
};
